export default __webpack_public_path__ + "static/media/footer.4972f4a6.png";